import React from 'react';
import './ui.css';
const Loader = () => (
  <div className="jumping-dots-loader" >
    <span></span>
    <span></span>
    <span></span>
  </div>
  // <div className="square-box-loader">
  //   <div className="square-box-loader-container">
  //     <div className="square-box-loader-corner-top" />
  //     <div className="square-box-loader-corner-bottom" />
  //   </div>
  //   <div className="square-box-loader-square" />
  // </div>
);

export default Loader;
